import React, { useState } from "react";
import PropTypes from "prop-types";

import { Modal } from "@wwg/ui";
import ModalActionBar from "shared/ModalActionBar";
import Button from "shared/Button";
import Input from "shared/@forms/Input";
import TextArea from "shared/@forms/TextArea";
import { Select } from "shared/Select/Select";
import { DateRangePickerButton } from "shared/DateRangePickerButton/DateRangePickerButton";

import styles from "./CreateEventModal.module.css";

export function CreateEventModal({ onCreate, isOpen, onClose }) {
  const [title, setTitle] = useState("");
  const [caseNum, setCaseNum] = useState("");
  const [location, setLocation] = useState("");
  const [notes, setNotes] = useState("");

  const [date, setDate] = useState("");
  const [hour, setHour] = useState("");
  const [minutes, setMinutes] = useState("");
  const [amPm, setAmPm] = useState("");

  const [reminderDays, setReminderDays] = useState("Select");

  const [fileList, setFileList] = useState([]);
  function handleFileUpload(e) {
    const files = [...e.target.files];
    setFileList([...files]);
  }

  return (
    <Modal
      onClose={onClose}
      visible={isOpen}
      onClick={onClose}
      children={
        <div className={styles.modalBody}>
          <div className={styles.title}> Create New </div>
          <div className={styles.hr}></div>

          <div className={styles.grid}>
            <div>
              <div className={styles.label}>Add Title</div>
              <Input
                name="title"
                placeholder={title}
                className={styles.input}
                onChange={(e) => setTitle(e.target.value)}
                onInput={() => {}}
              />
            </div>

            <div>
              <div className={styles.label}>Case Number</div>
              <Input
                name="caseNumber"
                placeholder={caseNum}
                className={styles.input}
                onChange={(e) => setCaseNum(e.target.value)}
                onInput={() => {}}
              />
            </div>

            <div>
              <div className={styles.label}>Location</div>
              <Input
                name="location"
                placeholder={location}
                className={styles.input}
                onChange={(e) => setLocation(e.target.value)}
                onInput={() => {}}
              />
            </div>

            <div>
              <div className={styles.dateRow}>
                <div className={styles.dateSelect} aria-label="Date Select">
                  <div className={styles.label}>Date</div>
                  <DateRangePickerButton
                    setStartDate={setDate}
                    setEndDate={() => {}}
                    startDateString={date}
                    allowPastDate={true}
                    allowRangeSelection={false}
                  />
                </div>

                <div>
                  <div className={styles.label}>Add Time</div>
                  <Select
                    options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
                    placeholder={hour}
                    onChange={setHour}
                  />
                </div>
                <div>
                  <div className={styles.label2}>q</div>
                  <Select
                    options={[":00", ":15", ":30", ":45"]}
                    placeholder={minutes}
                    onChange={setMinutes}
                  />
                </div>
                <div>
                  <div className={styles.label2}>q</div>
                  <Select
                    options={["am", "pm"]}
                    placeholder={amPm}
                    onChange={setAmPm}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={styles.label}>Notes</div>
          <TextArea
            name="notes"
            className={styles.textArea}
            placeholder=""
            onChange={(e) => setNotes(e.target.value)}
          />

          <div className={styles.fileUploadContainer}>
            <label htmlFor="documents" className={styles.fileUpload}>
              {fileList.length === 0
                ? "Upload Documents"
                : fileList.map((file, index) =>
                    index === fileList.length - 1
                      ? `${file.name}`
                      : `${file.name}, `
                  )}
            </label>
            <input
              className={styles.fileUpload}
              type="file"
              id="documents"
              onChange={(e) => handleFileUpload(e)}
              multiple
            />
          </div>

          <div className={styles.label}>Set Reminder</div>
          <div className={styles.reminderContainer}>
            <div>Remind me in </div>
            <div className={styles.select}>
              <Select
                options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]}
                placeholder={reminderDays}
                onChange={setReminderDays}
              />
            </div>
            <div> days.</div>
          </div>

          <ModalActionBar>
            <Button
              className={styles.createButton}
              onClick={() =>
                onCreate({
                  title: title,
                  caseNum: caseNum,
                  location: location,
                  notes: notes,
                  date: date,
                  time: hour + minutes + " " + amPm,
                  reminderDays: reminderDays,
                  files: fileList,
                })
              }
            >
              Create
            </Button>
          </ModalActionBar>
        </div>
      }
    ></Modal>
  );
}

CreateEventModal.propTypes = {
  /** Function called when the Create btn is clicked.  */
  onCreate: PropTypes.func,
  /** Getter to determine if modal is displayed  */
  isOpen: PropTypes.bool,
  /** Callback function for when the modal is closed  */
  onClose: PropTypes.func,
};
